import { QueryClient, type QueryKey } from "@tanstack/react-query";
import type { ErrorHandlerService } from "@/shared/services/error-handler.service";
import type { ErrorConfig, ErrorContext } from "@/shared/types/error.types";

// Only the leading segment: later segments are parameters and can hold a token or a search term.
const toQueryErrorContext = ([queryKeyName]: QueryKey): ErrorContext => ({ queryKeyName: typeof queryKeyName === "string" ? queryKeyName : undefined });

export const setupGlobalErrorHandler = (
  queryClient: QueryClient,
  errorHandlerService: ErrorHandlerService,
) => {
  // Handle mutation errors (POST, PUT, DELETE, etc.)
  queryClient.setDefaultOptions({
    mutations: {
      onError: (error, _variables) => {
        // Conserver le défaut historique pour les tests
        const errorConfig: ErrorConfig = { title: "Erreur", description: "Une erreur est survenue lors de l'opération" };
        errorHandlerService.handleError(error, errorConfig);
      },
    },
  });

  // Handle query errors (GET requests) using QueryCache
  queryClient.getQueryCache().config = {
    onError: (error, query) => {
      const errorConfig = query.meta?.errorConfig as ErrorConfig | undefined;
      errorHandlerService.handleError(error, errorConfig, toQueryErrorContext(query.queryKey));
    },
  };
};
